<template>
    <div class="news-container">
        <Nav :currentActive="'News'" />

        <div class="crumbs fixed">
           <div class="contain">
               <ul>
                   <li><a href="/" class="crumbs-home" ondragstart="return false"><i></i></a></li>
                   <li><i class="crumbs-arrow"></i></li>
                   <li><a href="/xinwen" ondragstart="return false">新闻资讯</a></li>
                   <li><i class="crumbs-arrow"></i></li>
                   <li><a href="/News/1" ondragstart="return false">大事记</a></li>
               </ul>
           </div>
       </div>

       <div class="article pt110 pb110">
            <div class="contain">
                <Detail83 v-if="nowPage == 83"/>
                <Detail80 v-if="nowPage == 80"/>
                <Detail109 v-if="nowPage == 109"/>
                <Detail61 v-if="nowPage == 61"/>
                <Detail60 v-if="nowPage == 60"/>
                <Detail59 v-if="nowPage == 59"/>
                
                <Detail58 v-if="nowPage == 58"/>
                <Detail56 v-if="nowPage == 56"/>
                <Detail55 v-if="nowPage == 55"/>
                <Detail54 v-if="nowPage == 54"/>
                <Detail39 v-if="nowPage == 39"/>
                <Detail38 v-if="nowPage == 38"/>
                <Detail37 v-if="nowPage == 37"/>
                <Detail36 v-if="nowPage == 36"/>
                <div class="art-sidebar">
                    <h2 class="tit fs22">相关新闻</h2>
                    <ul>
                        
                        <li>
                            <a href="https://mp.weixin.qq.com/s/uMIqRnbFLGYuoO8eDeLdSQ" ondragstart="return false">
                                <span class="time">2024-09-26</span>
                                <h3>鲁澳合作再谱新篇｜鲁澳数字认证服务中心项目签约</h3>
                            </a>
                        </li>
                        
                        <li>
                            <a href="https://mp.weixin.qq.com/s/5FTAb6RFcn4Ct4jVNI95hQ" ondragstart="return false">
                                <span class="time">2024-09-19</span>
                                <h3>澳门质量品牌国际认证联盟与全国农业展览馆合作推进国家地理标志农产品展示体验馆运营工作</h3>
                            </a>
                        </li>
                        
                        <li>
                            <a href="https://mp.weixin.qq.com/s/x1HxaoLbw5vf-eRjBYNCMQ" ondragstart="return false">
                                <span class="time">2024-07-28</span>
                                <h3>景德镇国家陶瓷版权交易中心与澳门贤滔投资有限公司、上海垤和数字科技有限公司合作座谈暨签约仪式成功举行</h3>
                            </a>
                        </li>
                        
                        <li>
                            <a href="https://mp.weixin.qq.com/s/dOV2iEvlP-Y2frR8PAl0nQ" ondragstart="return false">
                                <span class="time">2024-07-13</span>
                                <h3>澳门工商联携同澳门质量品牌国际认证联盟拜访葡萄牙经济部</h3>
                            </a>
                        </li>
                        
                        
                    </ul>
                </div>
            </div>
        </div>
        
        <Footer />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted, watch } from 'vue';
  import Nav from '../../components/NavTop.vue';
  import Footer from '../../components/Footer.vue';
  import { useRoute, useRouter } from 'vue-router';
  import Detail83 from './detail/detail83.vue';
  import Detail80 from './detail/detail80.vue';
  import Detail61 from './detail/detail61.vue';
  import Detail109 from './detail/detail109.vue';
  import Detail60 from './detail/detail60.vue';
  import Detail59 from './detail/detail59.vue';
  import Detail58 from './detail/detail58.vue';
  import Detail56 from './detail/detail56.vue';
  import Detail55 from './detail/detail55.vue';
  import Detail54 from './detail/detail54.vue';
  import Detail36 from './detail/detail36.vue';
  import Detail37 from './detail/detail37.vue';
  import Detail38 from './detail/detail38.vue';
  import Detail39 from './detail/detail39.vue';


  const startAnimate = ref(false)
  const nowPage = ref(1);

    const route = useRoute();
    const router = useRouter();



    // 监听路由参数变化
    watch(
        () => route.params.id,
        (newNumber) => {
            // 当参数变化时，这里可以执行更新逻辑
            console.log('数字参数已更新为:', newNumber);
            nowPage.value = newNumber - 0
            // 比如重新获取数据等操作
            // 手动将页面滚动到顶部
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth' // 可以根据需要设置滚动的动画效果，'smooth' 表示平滑滚动
            });
        },
        { immediate: true } // 初始化时也会触发一次
    );
  onMounted(() => {
    startAnimate.value = true
    nowPage.value = route.params.id - 0;

  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }
    .crumbs {
        width: 100%;
        background: #9ca6b7;
        z-index: 9999;
        color: #fff;
        padding: 12px 0;
    }
 .crumbs.fixed {
    position: fixed;
    top: 84px;
    left: 0;
    width: 100%;
}
.contain {
    margin: 0 auto;
    width: 1200px;
}
.article .contain {
    display: flex;
    justify-content: space-between;
}
.crumbs ul {
    display: flex;
    align-items: center;
}
.crumbs .crumbs-home i {
    display: block;
    background: url(@/assets/images/crumbs-home.png) no-repeat center / 100%;
    width: 33px;
    height: 27px;
}
.crumbs .crumbs-arrow {
    display: block;
    background: url(@/assets/images/arrRW.svg) no-repeat center / 100%;
    width: 14px;
    height: 14px;
    margin: 0 8px;
}


.article {
    background: #fafafa;
    overflow: hidden;
    padding: 90px 0;
}

.article .art-cont {
    background: #fff;
    width: calc(70% - 80px);
    padding: 50px 40px;
    overflow: hidden;
    border-radius: 8px;
}
.article .art-cont h1 {
    color: #333;
    font-weight: 700;
}
    .article .art-cont h1 {
        font-size: 26px;
    }

    .article .art-cont .title-info {
        font-size: 14px;
        color: #888;
        font-family: OPPOSans-H;
        padding-left: 30px;
        height: 20px;
        line-height: 22px;
        background: url(@/assets/images/news-time.png) no-repeat left center;
        margin: 30px 0;
    }

    .article .art-bott {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        align-items: center;
    }
    .article .art-bott .art-btn {
        background: #ea5413;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 42px;
        font-weight: 700;
        color: #fff;
        border-radius: 30px;
        transition: all .4s ease;
        font-size: 16px;
    }
    .btn-hvr:hover {
        border-color: transparent;
        box-shadow: 0 0 0 .2rem rgba(234, 84, 19, .5);
    }
    .article .arc-nav a {
        position: relative;
        display: block;
        font-size: 14px;
        color: #666;
        padding-left: 15px;
        transition: all .4s ease;
        font-weight: 700;
    }


    .art-sidebar {
        width: calc(28% - 60px);
        background: #fff;
        height: 100%;
        padding: 30px;
        overflow: hidden;
        border-radius: 8px;
    }
    .art-sidebar .tit {
        font-weight: 700;
        color: #333;
        font-size: 22px;
    }

    .art-sidebar li {
        padding-top: 20px;
        margin-top: 20px;
        border-top: 1px solid #f1f1f1;
    }

    .art-sidebar a .time {
        display: block;
        font-size: 13px;
        color: #888;
        font-family: OPPOSans-H;
    }

    .art-sidebar h3 {
        font-size: 16px;
        color: #333;
        line-height: 26px;
        margin-top: 16px;
        overflow: hidden;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        max-height: 52px;
    }

  </style>